<template>
  <div style="margin-top: 10px">
    <div style="display: flex; gap: 10px;">
      <b-form-group
        id="input-group-8"
        :label="$t('EditY')"
        label-for="input-25"
      >
        <vue-select
          v-model="year"
          :options="yearsArrays"
          style="width: 200px;"
          :clearable="false"
        />
      </b-form-group>
      <b-form-group
        id="input-group-8"
        :label="$t('Month')"
        label-for="input-25"
      >
        <vue-select
          v-model="month"
          :options="monthOptions"
          :reduce="(e) => e.value"
          label="name"
          style="width: 200px;"
          :clearable="false"
        />
      </b-form-group>
      <b-form-group
        id="input-select-1"
        :label="$t('SelectEmployee')"
        label-for="select-1"
        class="sales"
      >
        <vue-select
          v-model="salesUserId"
          :options="getUsersMultipleRoles"
          :reduce="(e) => e.userID"
          :placeholder="$t('Employees')"
          label="fullName"
          aria-describedby="input-1-live-feedback"
          :clearable="false"
        />
      </b-form-group>
      <PdfDocument
        :method-name="'soldItemsByUserPDF'"
        :getter-name="'getItemsSoldByUserPDF'"
        :pdf-name="'EmployeeSales'"
        :is-pagination="true"
        :header-name="header"
        :object-value="objectPDF"
        :start-date="month"
        :end-date="year"
        :person="selectedSalesPersonFullName"
        :pdf-title="$t('EmployeeSales')"
        style="margin-top: 1.3%;"
      />
      <button
        v-b-tooltip.hover="$t('DownloadExcel')"
        style="border: 0; width: 48px;
        height: 37px; background: #FF274F; border-radius: 5px; margin-top: 1.3%;"
        @click="downloadEXCEL"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="white"
          class="bi bi-file-earmark-spreadsheet"
          viewBox="0 0 16 16"
        >
          <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h3v2H6zm4 0v-2h3v1a1 1 0 0 1-1 1h-2zm3-3h-3v-2h3v2zm-7 0v-2h3v2H6z" />
        </svg>
      </button>
      <button
        v-b-tooltip.hover="$t('DownloadExcel')"
        style="border: 0; margin-top: 1.3%; padding: 6px 10px; height: 37px; background: #FF274F; border-radius: 5px; color: white; font-weight: 500; margin-left: 8px;"
        @click="downloadProcessorCounts"
      >
        {{ $t('SalesForAllEmployees') }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="white"
          class="bi bi-file-earmark-spreadsheet"
          viewBox="0 0 16 16"
        >
          <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h3v2H6zm4 0v-2h3v1a1 1 0 0 1-1 1h-2zm3-3h-3v-2h3v2zm-7 0v-2h3v2H6z" />
        </svg>
      </button>
    </div>
    <div
      style="width: 100%;  padding-top: 16px; margin-top: 15px; height: 75vh; overflow-y: scroll;"
      class="scroll"
    >

      <table
        ref="exportable_table"
        class="team_table"
      >
        <thead style="position: sticky; top: 1px">
          <tr style="text-align: center;">
            <th>
              {{ $t('OrderNumber') }}
            </th>
            <th>
              {{ $t('ArticleNumber') }}
            </th>
            <th>
              {{ $t('Price') }}
            </th>
            <th>
              {{ $t('paidAmount') }}
            </th>
            <th>
              {{ $t('Discount') }}
            </th>
          </tr>
        </thead>
        <tbody v-if="getItemsSoldByUser.length > 0">
          <tr
            v-for="(items, index) in getItemsSoldByUser"
            :key="index"
            style="text-align: center;"
          >
            <td>
              {{ items.orderNumber }}
            </td>
            <td>
              {{ items.articleNumber }}
            </td>
            <td>
              {{ items.price }}€
            </td>
            <td>
              {{ items.paidAmount }}€
            </td>
            <td>
              {{ items.discount }}
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td
              colspan="5"
              style="padding: 11px 16px"
            >
              {{ $t('NoSales') }}
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <b-pagination
          v-if="getTotalItemsSold > 1"
          v-model="pageNumber"
          :total-rows="getTotalItemsSold"
          :per-page="pageSize"
          first-number
          last-number
          align="fill"
          prev-class="prev-itemi"
          next-class="next-itemi"
          class="mt-1 mb-0"
        >
          <template #prev-text>
            <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
          </template>
          <template #next-text>
            <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex';
import PdfDocument from '@/components/PdfDocument/DownloadPDF.vue'
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { client } from '../domainConfig'

export default {
  components: {
    PdfDocument,
  },
  data() {
    return {
      month: moment().month() + 1,
      year: moment().year(),
      client: client.clientName,
      salesUserId: null,
      pageNumber: 1,
      pageSize: 15,
      status: true,
      userID: null,
      header: [
        {
          orderNumber: this.$t('OrderNumber'),
          articleNumber: this.$t('articleNumber'),
          price: this.$t('Price'),
          paidAmount: this.$t('paidAmount'),
          discount: this.$t('Discount'),
          remainingPrice: this.$t('RemainingAmount'),
        },
      ],
      monthOptions: [
        {
          value: 1,
          name: this.$t('January'),
        },
        {
          value: 2,
          name: this.$t('February'),
        },
        {
          value: 3,
          name: this.$t('March'),
        },
        {
          value: 4,
          name: this.$t('April'),
        },
        {
          value: 5,
          name: this.$t('May'),
        },
        {
          value: 6,
          name: this.$t('June'),
        },
        {
          value: 7,
          name: this.$t('July'),
        },
        {
          value: 8,
          name: this.$t('August'),
        },
        {
          value: 9,
          name: this.$t('September'),
        },
        {
          value: 10,
          name: this.$t('October'),
        },
        {
          value: 11,
          name: this.$t('November'),
        },
        {
          value: 12,
          name: this.$t('December'),
        },
      ],
    }
  },
  computed: {
    ...mapGetters([
      'getItemsSoldByUser',
      'getUsersMultipleRoles',
      'getUserRole',
      'getLoggedInUser',
      'getItemsSoldByUserPDF',
      'getTotalItemsSold',
    ]),
    objectPDF() {
      return {
        month: this.month,
        year: this.year,
        salesUserId: this.salesUserId,
        pageNumber: this.pageNumber,
        pageSize: 50,
      }
    },
    yearsArrays() {
      const result = [];
      const baseYear = this.year || moment().year();

      for (let i = -3; i < 4; i++) {
        result.push(baseYear + i);
      }

      return result;
    },
    selectedSalesPersonFullName() {
      const selectedUser = this.getUsersMultipleRoles.find((user) => { return user.userID === this.salesUserId });
      return selectedUser ? selectedUser.fullName : '';
    },
  },
  watch: {
    pageNumber(value) {
      if (value) {
        this.soldItemsByUser({
          month: this.month,
          year: this.year,
          salesUserId: this.salesUserId,
          pageNumber: value,
          pageSize: this.pageSize,
        })
      }
    },
    month(newValue) {
      if (newValue && this.year && this.salesUserId) {
        this.callSalesByUser();
      }
    },
    year(newValue) {
      if (newValue && this.month && this.salesUserId) {
        this.callSalesByUser()
      }
    },
    salesUserId(newValue) {
      if (newValue && this.month && this.year) {
        this.callSalesByUser()
      }
    },
  },
  mounted() {
    this.usersByMultipleRoles({
      status: true,
      object: ['SalesPerson', 'OnlineSales', 'Designer', 'TeamLeader', 'TeamLeaderPattern', 'Manager'],
    })
    this.getUsersRole()
  },
  methods: {
    ...mapActions([
      'soldItemsByUser',
      'usersByMultipleRoles',
      'getUsersRole',
      'soldItemsByUserPDF',
      'exportProcessorCounts',
    ]),
    callSalesByUser() {
      this.soldItemsByUser({
        month: this.month,
        year: this.year,
        salesUserId: this.salesUserId,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
    },
    generateTableContentCSV(data) {
      const headers = [this.$t('OrderNumber'), this.$t('ArticleNumber'), this.$t('Price'), this.$t('paidAmount'), this.$t('RemainingAmount')];
      const body = [];

      data.forEach((item) => {
        const remainingPrice = parseFloat((item.price - item.paidAmount).toFixed(2));

        body.push([
          item.orderNumber,
          item.articleNumber,
          item.price,
          item.paidAmount,
          remainingPrice,
        ]);
      });

      return { headers, body };
    },
    generateExcel(tableContent) {
      const { headers, body } = tableContent;
      const sheetData = [headers, ...body];

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const excelData = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      return excelData;
    },

    downloadEXCEL() {
      this.soldItemsByUser({
        month: this.month,
        year: this.year,
        salesUserId: this.salesUserId,
        pageNumber: this.pageNumber,
        pageSize: 15,
      }).then(() => {
        const tableContent = this.generateTableContentCSV(this.getItemsSoldByUserPDF.items);

        const totalPages = this.getItemsSoldByUserPDF.totalPages;
        const additionalPromises = [];
        for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
          additionalPromises.push(this.downloadPage(pageNumber));
        }

        Promise.all(additionalPromises).then((additionalTableContents) => {
          additionalTableContents.forEach((additionalTableContent) => {
            tableContent.body = tableContent.body.concat(additionalTableContent.body);
          });

          const excelData = this.generateExcel(tableContent);
          FileSaver.saveAs(excelData, 'EmployeeSales.xlsx');
        });
      });
    },
    downloadPage(pageNumber) {
      return this.soldItemsByUser({
        month: this.month,
        year: this.year,
        salesUserId: this.salesUserId,
        pageNumber,
        pageSize: 15,
      })
        .then(() => {
          return this.generateTableContentCSV(this.getItemsSoldByUserPDF.items);
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
    },
    downloadProcessorCounts() {
      if (!this.year || !this.month) {
        window.alert(this.$t ? this.$t('SelectD') : 'Please select year and month');
        return;
      }

      this.exportProcessorCounts({ year: this.year, month: this.month })
        .then((res) => {
          if (res instanceof Blob) {
            return res.text().then((t) => {
              try { return JSON.parse(t); } catch (e) { return t; }
            });
          }
          return res;
        })
        .then((data) => {
          if (!data || !Array.isArray(data)) {
            console.error('Unexpected processor-counts response format', data);
            return;
          }

          const eventCountSet = new Set();
          data.forEach((user) => {
            const breakdown = user.breakdown || [];
            breakdown.forEach((b) => {
              const ec = Number.isFinite(b.eventCount) ? b.eventCount : 0;
              eventCountSet.add(ec);
            });
          });

          const eventCounts = Array.from(eventCountSet).sort((a, b) => a - b);

          const headers = [this.$t('Executor') || 'Sales User', ...eventCounts.map((ec) => `${this.$t('NumberOfPeople')} ${ec}`)];

          const body = [];

          data.forEach((user) => {
            const name = user.salesUserFullName || user.salesUserName || '';
            const breakdown = user.breakdown || [];

            const countsByEvent = {};
            breakdown.forEach((b) => {
              const ec = Number.isFinite(b.eventCount) ? b.eventCount : 0;
              const cnt = Number(b.orderItemCount) || 0;
              countsByEvent[ec] = (countsByEvent[ec] || 0) + cnt;
            });

            const row = [name];
            eventCounts.forEach((ec) => {
              row.push(countsByEvent[ec] || 0);
            });

            body.push(row);
          });

          const tableContent = { headers, body };
          const excelData = this.generateExcel(tableContent);
          const filenameBase = this.$t('MonthSalesForAllEmployees') || 'EmployeeSales';
          const filename = `${filenameBase}_${this.year}_${String(this.month).padStart(2, '0')}.xlsx`;
          FileSaver.saveAs(excelData, filename);
        })
        .catch((err) => {
          console.error('Error exporting processor counts', err);
        });
    }
  },
}
</script>

<style scoped>
.sales {
  width: 12%;
}
.team_table td {
  padding: 16px!important;
}
@media screen and (max-width: 1200px) {
  .sales {
    width: 21%;
  }
}
</style>
